// extracted by mini-css-extract-plugin
export default {"create":"QuestionHistory_create__krTQV","edit":"QuestionHistory_edit__-HSET"};